import { useId, useRef } from "react";

function generateUuidV4(): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.getRandomValues === "function"
  ) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    const lowNibble = bytes[6] % 16;
    bytes[6] = 0x40 + lowNibble;
    const lowSixBits = bytes[8] % 64;
    bytes[8] = 0x80 + lowSixBits;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));
    return `${hex[0]}${hex[1]}${hex[2]}${hex[3]}-${hex[4]}${hex[5]}-${hex[6]}${hex[7]}-${hex[8]}${hex[9]}-${hex[10]}${hex[11]}${hex[12]}${hex[13]}${hex[14]}${hex[15]}`;
  }
  return Math.random().toString(36).slice(2, 11);
}

export function useStableId(prefix = "id"): string {
  const reactId = useId();
  const idRef = useRef<string>("");
  if (!idRef.current) {
    const base = reactId ? reactId.replace(/:/g, "") : generateUuidV4();
    idRef.current = prefix ? `${prefix}-${base}` : base;
  }
  return idRef.current;
}
